module.exports = __webpack_public_path__ + "static/media/qingming6Bg.ddfde7bc.jpg";